import React from "react";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-calendars/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-lists/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";

const SFDateRangeSelector = ({
  value,
  onChange,
  wrapperClassName = "m-4",
  compact = false,
  /** Tighter wrapper + wider Syncfusion field for admin top-row tiles */
  adminToolbar = false,
}) => {
  // Calculate preset ranges
  const now = new Date();
  const previous7Days = [
    new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7),
    now,
  ];
  const previous28Days = [
    new Date(now.getFullYear(), now.getMonth(), now.getDate() - 28),
    now,
  ];
  const previous6Months = [
    new Date(now.getFullYear(), now.getMonth() - 6, now.getDate()),
    now,
  ];

  const presets = [
    {
      label: "Previous 7 Days",
      start: previous7Days[0],
      end: previous7Days[1],
    },
    {
      label: "Previous 28 Days",
      start: previous28Days[0],
      end: previous28Days[1],
    },
    {
      label: "Previous 6 Months",
      start: previous6Months[0],
      end: previous6Months[1],
    },
  ];

  const wrapperClass =
    adminToolbar ? "m-0 w-full min-w-0 max-w-full flex flex-col justify-center" : wrapperClassName;
  const labelClass =
    adminToolbar || compact
      ? "text-black text-sm font-semibold mb-0.5 leading-tight"
      : "text-black text-lg font-semibold";

  return (
    <div className={wrapperClass}>
      <div className={labelClass}>Select Date Range</div>
      <style>
        {`
          /* Main input field styling - using official Syncfusion selectors */
          .e-input-group input.e-input, .e-input-group.e-control-wrapper input.e-input {
            font-size: 0.95rem !important;
            color: black !important;
          }
          
          /* DateRangePicker specific input styling */
          .e-daterangepicker .e-input-group input.e-input {
            font-size: 0.95rem !important;
            color: black !important;
          }
          
          /* Calendar content styling */
          .e-daterangepicker.e-popup .e-calendar .e-content td {
            font-size: 0.95rem !important;
          }
          
          .e-daterangepicker.e-popup .e-calendar .e-content th {
            font-size: 0.95rem !important;
          }
          
          /* Calendar header title styling */
          .e-daterangepicker.e-popup .e-calendar .e-header .e-title {
            font-size: 0.95rem !important;
          }

          .sf-drp-admin-toolbar.e-daterangepicker {
            width: 100% !important;
            max-width: 100%;
          }
          .sf-drp-admin-toolbar .e-input-group.e-control-wrapper {
            width: 100% !important;
            max-width: 100%;
            min-width: min(100%, 380px);
          }
          .sf-drp-admin-toolbar .e-input-group input.e-input {
            min-width: 11rem !important;
          }
        `}
      </style>
      <DateRangePickerComponent
        value={value}
        showClearButton={false}
        max={now}
        change={(e) => {
          // Handle the change event
          const selectedRange = e.value; // [startDate, endDate]
          if (selectedRange && selectedRange.length === 2) {
            const [startDate, endDate] = selectedRange;
            onChange([startDate, endDate]); // Pass the updated range to parent
          }
        }}
        presets={presets}
        width="100%"
        cssClass={adminToolbar ? "sf-drp-admin-toolbar" : undefined}
        format="dd/MM/yyyy" // Ensures date is displayed in dd/MM/yyyy format
      />
    </div>
  );
};

export default SFDateRangeSelector;
